import { atom } from 'jotai'

type Input = {
  isRenderGlobalNavigation: boolean
  isRenderRoomPageHeader: boolean
  isRenderRoomTable: boolean
}

const state = atom<Input>({
  isRenderGlobalNavigation: false,
  isRenderRoomPageHeader: false,
  isRenderRoomTable: false,
})
export const renderStatusStore = { state } as const
